(() => {
  const collectionAliases = new Map([
    ["/collections/keyboards", "/collections/all-keyboards"],
    ["/collections/mice", "/collections/gaming-mice"],
    ["/collections/accessories", "/collections/all-accessories"],
    ["/collections/magnetic-keyboards", "/collections/hall-effect-keyboards"],
    ["/collections/he-keyboards", "/collections/hall-effect-keyboards"],
    ["/collections/converters", "/collections/converters-hubs"],
    ["/collections/joysticks", "/collections/controllers"]
  ]);

  const canonicalPath = collectionAliases.get(window.location.pathname);

  if (canonicalPath) {
    window.location.replace(`${canonicalPath}${window.location.search}${window.location.hash}`);
    return;
  }

  const rewriteLegacyCollectionLinks = (root = document) => {
    root.querySelectorAll('a[href*="/collections/"]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      const replacement = collectionAliases.get(url.pathname);

      if (replacement) {
        url.pathname = replacement;
        link.href = url.toString();
      }
    });
  };

  const initImpactRailCompression = (root = document) => {
    root.querySelectorAll(".shopify-section--impact-text .impact-text").forEach((rail) => {
      if (rail.dataset.ftCompressionReady === "true") {
        return;
      }

      rail.dataset.ftCompressionReady = "true";

      let frame;

      const update = () => {
        frame = undefined;

        const mobile = window.matchMedia("(max-width: 699px)").matches;
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const railBounds = rail.getBoundingClientRect();
        const railCenter = railBounds.left + railBounds.width / 2;
        const compressionRange = Math.max(rail.clientWidth * .58, 1);

        rail.querySelectorAll(":scope > .snap-center").forEach((card) => {
          if (!mobile || reducedMotion) {
            card.style.removeProperty("--ft-rail-compression");
            card.style.removeProperty("--ft-rail-direction");
            return;
          }

          const cardBounds = card.getBoundingClientRect();
          const cardCenter = cardBounds.left + cardBounds.width / 2;
          const signedDistance = (cardCenter - railCenter) / compressionRange;
          const distance = Math.min(Math.abs(signedDistance), 1);
          card.style.setProperty("--ft-rail-compression", distance.toFixed(3));
          card.style.setProperty("--ft-rail-direction", String(Math.sign(signedDistance)));
        });
      };

      const requestUpdate = () => {
        if (frame === undefined) {
          frame = window.requestAnimationFrame(update);
        }
      };

      rail.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate, { passive: true });
      new ResizeObserver(requestUpdate).observe(rail);
      requestUpdate();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      rewriteLegacyCollectionLinks();
      initImpactRailCompression();
    }, { once: true });
  } else {
    rewriteLegacyCollectionLinks();
    initImpactRailCompression();
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          rewriteLegacyCollectionLinks(node);
          initImpactRailCompression(node);
        }
      });
    });
  });

  document.addEventListener("DOMContentLoaded", () => {
    observer.observe(document.body, { childList: true, subtree: true });
  }, { once: true });
})();
